import { ImageListItem } from '@mui/material';
import loginLogo from 'assets/images/login/login-logo.svg';

function LoginSideLogo(): JSX.Element {
  return (
    <ImageListItem
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        padding: 5,
      }}
    >
      <img
        src={`${loginLogo}`}
        alt="mindcode"
        loading="lazy"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          maxWidth: '600px',
        }}
      />
    </ImageListItem>
  );
}

export default LoginSideLogo;
